import ErrorModal from './ErrorModal'
import { CartErrorMessage } from 'shop/types/cart'
import {
  getFulfillmentTypeLabel,
  getOppositeFulfillmentType
} from 'shop/utils/common'

type InvalidFulfillmentTypeModalProps = {
  currentFulfillmentType: string
  isFulfillmentToggleTriggered: boolean
  onContinue: () => void
}

const InvalidFulfillmentTypeModal = ({
  currentFulfillmentType,
  isFulfillmentToggleTriggered,
  onContinue
}: InvalidFulfillmentTypeModalProps) => {
  const oppositeFulfillmentTypeKey =
    getOppositeFulfillmentType[currentFulfillmentType]
  const oppositeFulfillmentTypeLabel =
    getFulfillmentTypeLabel[oppositeFulfillmentTypeKey]

  const unavailableFulfillmentTypeLabel = isFulfillmentToggleTriggered
    ? oppositeFulfillmentTypeLabel
    : getFulfillmentTypeLabel[currentFulfillmentType]

  return (
    <ErrorModal
      errorCode={CartErrorMessage.INVALID_FULFILLMENT_TYPE}
      primaryButton={{ message: 'Continue', onClick: onContinue }}
      errorTitle={`${unavailableFulfillmentTypeLabel} unavailable`}
      errorMessages={[
        `Unfortunately, ${unavailableFulfillmentTypeLabel} is no longer available at this store. Please try another store or fulfillment option`
      ]}
    />
  )
}

export default InvalidFulfillmentTypeModal
